module.exports = __webpack_public_path__ + "assets/images/chapeu_3e765a9258961d85e082763f23b5b35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cone/chapeu.png
// module id = 193
// module chunks = 0